import { render, staticRenderFns } from "./TenderItem.vue?vue&type=template&id=189a0db6&scoped=true"
import script from "./TenderItem.vue?vue&type=script&lang=js"
export * from "./TenderItem.vue?vue&type=script&lang=js"
import style0 from "./TenderItem.vue?vue&type=style&index=0&id=189a0db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a0db6",
  null
  
)

export default component.exports